import { CreateMyWishlistInput } from '@spa/generated/graphql/graphql';
import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCreateMyWishlistRequestedPayload {
  readonly actionId: number;
  readonly input: CreateMyWishlistInput;
  readonly parentActionId: number;
}

export const apiCreateMyWishlistRequestedType = 'api/wishlist/createMyWishlist--requested';
export const apiCreateMyWishlistRequested = createAction<ApiCreateMyWishlistRequestedPayload>(
  apiCreateMyWishlistRequestedType
);
export type ApiCreateMyWishlistRequestedAction = ReturnType<typeof apiCreateMyWishlistRequested>;

export interface ApiCreateMyWishlistSucceededPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly result: StateWishlist;
}

export const apiCreateMyWishlistSucceededType = 'api/wishlist/createMyWishlist--succeeded';
export const apiCreateMyWishlistSucceeded = createAction<
  ApiCreateMyWishlistSucceededPayload,
  typeof apiCreateMyWishlistSucceededType
>(apiCreateMyWishlistSucceededType);
export type ApiCreateMyWishlistSucceededAction = ReturnType<typeof apiCreateMyWishlistSucceeded>;

export interface ApiCreateMyWishlistFailedPayload {
  readonly parentActionId: number;
  readonly requestedActionId: number;
  readonly error: WishlistError;
}

export const apiCreateMyWishlistFailedType = 'api/wishlist/createMyWishlist--failed';
export const apiCreateMyWishlistFailed = createAction<
  ApiCreateMyWishlistFailedPayload,
  typeof apiCreateMyWishlistFailedType
>(apiCreateMyWishlistFailedType);
export type ApiCreateMyWishlistFailedAction = ReturnType<typeof apiCreateMyWishlistFailed>;
